module.exports = __webpack_public_path__ + "static/media/1003020.1a72053f.jpg";